<template>
  <div class="user-team-widget d-flex align-content-center justify-content-between">
    <!-- Confirmation dialog for removal -->
    <popup
        v-if="showConfirmDialog"
        :elevated-z-index="10005"
        @close="showConfirmDialog = false"
    >
      <div slot="popupMainContent">
        <delete-prompt
            :custom-message="confirmMessage"
            button-abort-text="abort"
            button-confirm-text="confirm"
            @abort="showConfirmDialog = false"
            @confirm="$emit('removeTeam', team.id); showConfirmDialog = false"
        />
      </div>
    </popup>

    <div>
      {{ teamName }} <span class="lighter" v-if="team.visibility === 0">({{ $t('private') }})</span>
    </div>
    <div class="d-flex align-content-center">
      <div v-if="calculatedRole !== teamRole" class="lighter float-right">(Organization: {{ calculatedRole }})</div>
      <role-selector
          :pre-selected-role="teamRole"
          :read-only="readOnly"
          class="role-selector ml-2"
          @update="updateTeamRole"
      />
      <div class="ml-5">
        <checkbox-widget
            :key="forceReRenderKey"
            :disabled="readOnly"
            :initial-value="teamDefault"
            :label-text="$t('default')"
            :label-for="'default-' + team.id"
            @change="emitDefault"
        />
      </div>
      <div
          v-if="!readOnly"
          @click="confirmTeamRemoval"
          class="ml-2 clickable lighter">
        <icon
            size="1"
            type="close"
            class="pointer"
        />
      </div>
    </div>

  </div>
</template>

<script>
import RoleSelector from "@/components/organizations/RoleSelector.vue";
import Icon from "@/components/Icon.vue";
import {UserRoles} from "@/enum";
import DeletePrompt from "@/components/forms/DeletePrompt.vue";
import Popup from "@/components/Popup.vue";
import CheckboxWidget from "@/components/widgets/editors/Checkbox.vue";

export default {
  name: "UserTeam",
  components: {CheckboxWidget, Popup, DeletePrompt, Icon, RoleSelector},
  props: {
    team: {
      type: Object,
      required: true
    },
    organizationRole: {
      type: String,
      required: true
    },
    readOnly: { type: Boolean, default: false },
    userId: {
      type: String,
      required: true
    },
    freshAddedItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      isDefault: false,
      confirmMessage: '',
      showConfirmDialog: false,
      forceReRenderKey: 0,
    };
  },
  computed: {
    rolesHierarchy() {
      return Object.values(UserRoles);
    },
    calculatedRole() {
      const index = this.rolesHierarchy.indexOf(this.teamRole);
      const index2 = this.rolesHierarchy.indexOf(this.organizationRole);
      if (index2 < index) {
        return this.teamRole;
      } else {
        return this.organizationRole;
      }
    },
    updateTeamRole() {
      return (role) => {
        if(this.teamRole !== role) {
          this.$emit('updateTeamRole', this.team.id, role);
        }
      }
    },
    teamName() {
      return this.team.displayName;
    },
    teamRole() {
      const {members} = this.team;
      if (members && members[0]) {
        const {relation} = members[0];
        if (relation) {
          return relation.role;
        }
      }
      return 'none';
    },
    teamDefault() {
      const {members} = this.team;
      if (members && members[0]) {
        const {relation} = members[0];
        if (relation) {
          return relation.default;
        }
      }
      return false;
    },
  },
  watch: {
    teamDefault() {
     this.forceReRenderKey++;
    }
  },
  methods: {
    emitDefault(val) {
      if(this.readOnly || val === this.teamDefault) {
        return;
      }
      this.$emit('updateTeamDefault', this.team.id, !this.teamDefault);
    },
    confirmTeamRemoval() {
      this.showConfirmDialog = true;
      this.confirmMessage = this.$t('confirmRemoveFrom', {
        type: 'Team',
        name: this.$store.getters.getUserName(this.userId),
        itemName: this.teamName
      });
    },
  }
}
</script>

<style lang="scss">
.user-team-widget {


  .role-selector-dropdown {
    background-color: var(--vform-editor-ui-secondary-color);
  }

  .clickable {
    cursor: pointer;
    &:hover {
      color: var(--color-text-primary);
    }
  }
}
</style>